import { render, staticRenderFns } from "./MyHeader.vue?vue&type=template&id=6e54e0b6&scoped=true"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"
import style0 from "./MyHeader.vue?vue&type=style&index=0&id=6e54e0b6&prod&lang=less&scoped=true"
import style1 from "./MyHeader.vue?vue&type=style&index=1&id=6e54e0b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54e0b6",
  null
  
)

export default component.exports